<div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
  <div class="bfx-input-label">
    <p-checkbox
      [bfxInputLabelOnClick]="chkBoxLabel"
      class="icd__base__checkbox bfx-checkbox-enable-control"
      binary="true"
      [disabled]="auxCheckbox.locked || disabled || locked || auxCheckbox.permanentLock"
      [(ngModel)]="auxCheckbox.value"
      (onChange)="onAuxCheckboxChange()"
      [style.display]="auxCheckbox.enabled ? 'flex' : 'none'"
    ></p-checkbox>
    <div [ngClass]="inputDirective.labelClasses" #chkBoxLabel>{{ label }}</div>
  </div>
</div>

<div
  [ngClass]="{
    'bfx-radio-container': true,
    'icd__radio-button': true,
    'disabled': disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)
  }"
>
  <p-radioButton
    class="bfx-radiobutton-bold"
    [value]="data.dataset[0].value"
    [label]="data.dataset[0].label"
    [(ngModel)]="data.optionValue"
    (onClick)="clickEvent()"
    [disabled]="disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)"
  >
    ></p-radioButton
  >
  <p-radioButton
    class="bfx-radiobutton-bold"
    [value]="data.dataset[1].value"
    [label]="data.dataset[1].label"
    [(ngModel)]="data.optionValue"
    (onClick)="clickEvent()"
    [disabled]="disabled || data.disabled || locked || (auxCheckbox.enabled && !auxCheckbox.value)"
  ></p-radioButton>
</div>
